import { Dialog } from "@mui/material";
import { useCallback, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import DialogContentSelecionarNotaFiscal from "../../../../../components/DialogContentSelecionarNotaFiscal";
import { notaFiscalEntradaDefValue } from "../../../../../types/api/fiscal/pesquisar-nota-fiscal-entrada";
import useMobileScreen from "../../../../../lib/useMobileScreen";
import FormRecebimentoMercadorias from "./FormRecebimentoMercadorias";
import { IDataProdutoNF } from "./FormRecebimentoMercadorias/CardProdutos";

export default function DialogRegistrarRecebimentoMercadorias({
    open,
    handleClose,
}: DialogRegistrarRecebimentoMercadoriasProps) {

    const telaMobile = useMobileScreen();
 

    const [activeStep, setActiveStep] = useState<number>(0);
    const [modalContent, setModalContent] = useState<TModalContent>("selecionarNotaFiscal")

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue } = methods

    //Funções Manipuladoras
    const handleConfirm = useCallback(() => {
        if (modalContent === "selecionarNotaFiscal") {
            setModalContent("recebimentoMercadorias")
        }
    }, [modalContent])

    const handleBack = useCallback(() => {
        setModalContent("selecionarNotaFiscal")
    }, [])

    const onCloseModal = () => {
        handleClose()
    }

    return (
        <Dialog
            open={open}
            fullWidth
            fullScreen={telaMobile || modalContent === "recebimentoMercadorias"}
            scroll="body"
        >
            <FormProvider {...methods}>
                {
                    modalContent === "selecionarNotaFiscal" &&
                    <DialogContentSelecionarNotaFiscal
                        defaultValue={getValues("notaFiscal")}
                        {...{ handleClose }}
                        onChange={(value: any) => {
                            setValue("notaFiscal", value)
                            handleConfirm()
                        }}
                        extraParams={{ recebimento_mercadoria: 'true', tipo_nota: 'venda'}}
                    />
                }
                {
                    modalContent === "recebimentoMercadorias" &&
                    <FormRecebimentoMercadorias
                        onBack={() => {
                            setActiveStep(0)
                            handleBack()
                        }}
                        handleClose={() => onCloseModal()}
                        onCleanForm={() => {
                            setActiveStep(0)
                            setModalContent("selecionarNotaFiscal")
                        }}
                        {...{ modalContent, activeStep }}
                    />
                }
            </FormProvider>
        </Dialog>
    )
}

export const defaultValuesForm = {
    notaFiscal: notaFiscalEntradaDefValue,
    produtosNF: [] as IDataProdutoNF[],
}

interface DialogRegistrarRecebimentoMercadoriasProps {
    open: boolean,
    handleClose: () => void,
}

export type TModalContent = "selecionarNotaFiscal" | "recebimentoMercadorias"
